// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
/* for components whose styles are define, those components will pick below two configurable colors */
/* 
 - for components whose styles are not defined, those components will pick below two default colors* 
 - add styles for those components if you want configurable colors.
 - @primary-color and @secondary-color cannot be changed because it is used by antd, if removed it will default to antd default primary and secondary color.
 - this is a workaround as antd core styles do not accept css variables as less variable values.
*/
::selection {
  background-color: var(--app-primary-color);
  color: #fff;
}
.index-module__title-container__DYcHG {
  display: flex;
  justify-content: flex-start;
  gap: 30px;
  align-items: center;
}
.index-module__extra-container__HvwDj {
  text-align: center;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 30px;
}
.index-module__parking-history-filters__C6JA4 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  margin-top: -1rem;
}
.index-module__scrollContainer__fDMwk {
  max-height: 65vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 8px;
}
.index-module__vehicleQuotaTable__xlnwT {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.index-module__tableHeader__s0TcY,
.index-module__tableRow__UW0FM {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.index-module__tableHeader__s0TcY {
  font-weight: bold;
  padding-bottom: 8px;
  border-bottom: 1px solid #ccc;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1;
}
.index-module__datepicker__width__qsR7w {
  width: 24vw;
}
.index-module__dropdown__selector__Fe5og {
  width: 18vw;
  font-size: 14px;
  border-radius: 7px;
}
.index-module__dropdown__selector_small__KfIC3 {
  width: 14vw;
  font-size: 14px;
  border-radius: 7px;
}
.index-module__dropdown-filter-label__MwYe9 {
  font-size: 15px;
  font-weight: bolder;
}
.index-module__head-container__b7Fke {
  width: 100% !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.index-module__head-container-1__BJ6rM {
  display: none;
}
.index-module__select-master__GFaHW {
  margin-left: 200px;
  margin-top: -17px;
  display: flex;
  justify-content: flex-start;
}
.index-module__input-dropdown__0NJQy {
  width: 100%;
}
.index-module__input-search__NTAy_ {
  min-width: 100%;
}
.index-module__div-container__XI6nT {
  position: absolute;
  top: 10px;
  padding-left: 184px;
  display: flex;
  width: 100%;
}
.index-module__search-container__yThly {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10%;
  width: 100%;
}
.index-module__select-master-dropdown__rxobb {
  width: 250px;
}
.index-module__icon-delete-close__Tb02h {
  font-size: 23px;
}
.index-module__icon-save__a2QOK {
  font-size: 23px;
  margin-right: 25px;
}
.index-module__action-icon__ciGZ7 {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  margin-right: 1rem;
}
.index-module__logo-image-icon__fyvO2 {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 40px;
}
.index-module__delete-customer-icon__IugiB {
  color: red;
  font-size: 20px;
  margin-left: 10px;
}
.index-module__image__r1fUM {
  width: 50px;
  height: 50px;
}
.index-module__disabled__K_EBg {
  color: grey;
  cursor: not-allowed !important;
}
.index-module__button-m01__d1Z15 {
  margin: 0rem 1rem;
}
.index-module__form-itemFloatR20__KIl99 {
  float: right;
  margin-top: 20px;
}
.index-module__textCenter__mnCva {
  text-align: center;
}
.index-module__formDiv__sCkl4 {
  margin-top: 0px;
  padding-bottom: 3rem;
  padding-top: 0px;
}
.index-module__formDivExtended__grysV {
  padding-left: 1rem;
  padding-right: 1rem;
}
.index-module__from-Item-selectDiv__b8p08 {
  width: 100%;
}
.index-module__ant-select-option__fPCuf {
  max-height: 200px;
  overflow-y: auto;
}
.index-module__master-data-table__vqMci {
  margin-top: 1.6rem;
}
.index-module__master-container__C1aHC {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.index-module__master-container__C1aHC .index-module__section1__b7vAH {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 2rem;
}
.index-module__master-container__C1aHC .index-module__section2___NDzc {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
}
.index-module__mb8__OjmFl {
  margin-bottom: 8px;
}
.index-module__excel-button-container__YQ6SZ {
  padding: 0;
  margin-left: 10px;
}
.index-module__excel-icon__Pvvpt {
  color: green;
  font-size: 28px;
}
.index-module__pdf-icon__JEmn2 {
  color: red;
  font-size: 34px;
  cursor: pointer;
}
.index-module__pdf-icon-disabled__SZAuY {
  color: gray;
  font-size: 34px;
  cursor: not-allowed;
}
.index-module__highlighted-record-isVisitor__OfyZt {
  background-color: rgba(52, 152, 179, 0.5) !important;
  color: #000000;
}
.index-module__highlighted-record-booking__UIUwR {
  background-color: rgba(126, 196, 95, 0.5) !important;
  color: #000000;
}
.index-module__highlighted-record-retrieval__UAx1L {
  background-color: rgba(52, 152, 179, 0.5) !important;
  color: #000000;
}
.index-module__highlighted-record-storage__yXFSo {
  background-color: rgba(245, 127, 42, 0.5) !important;
  color: #000000;
}
.index-module__button-font-size__CFKZ2 {
  font-size: 18px;
}
.index-module__stats-container__PhUZe {
  margin-top: -10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 10px;
  gap: 20px;
  font-size: 14px;
}
.index-module__spacing-between-counts__NqDsz {
  margin-left: 15px;
}
.index-module__master-filters__U0S1F {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
  margin-top: 15px;
  margin-bottom: -7px;
}
.index-module__filter-master-dropdown__luKmK {
  width: 213px;
}
.index-module__advance-booking-container__uyuxl {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100% !important;
}
.index-module__advance-booking-container__uyuxl .index-module__field-section__OSNYo {
  width: 100% !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes index-module__blink-booking__LMf8d {
  0% {
    background-color: rgba(126, 196, 95, 0.5);
  }
  50% {
    background-color: #ff7400;
  }
  100% {
    background-color: rgba(126, 196, 95, 0.5);
  }
}
@keyframes index-module__blink-retrieval__lwlFa {
  0% {
    background-color: rgba(52, 152, 179, 0.5);
  }
  50% {
    background-color: #ff7400;
  }
  100% {
    background-color: rgba(52, 152, 179, 0.5);
  }
}
.index-module__blinking-record-execution-booking__lfFSj {
  animation: index-module__blink-booking__LMf8d 1s linear infinite;
  color: #000000;
}
.index-module__blinking-record-execution-retrieval__HUb9k {
  animation: index-module__blink-retrieval__lwlFa 1s linear infinite;
  color: #000000;
}
.index-module__text-bold__feQch {
  font-weight: bolder;
}
.index-module__filters-container__l6edW {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.index-module__show-date-filter-value__bfxDG {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  margin-top: 1rem;
}
.index-module__iconButton-container__HVBVa {
  display: flex;
  align-items: center;
  margin: 0px;
}
@media only screen and (max-width: 700px) {
  .index-module__select-master-dropdown__rxobb {
    width: 150px !important;
  }
  .index-module__input-search__NTAy_ {
    display: none;
  }
}
.index-module__header-container__rxhjb {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.index-module__filters-container__l6edW {
  display: flex;
  align-items: center;
  gap: 12px;
  align-content: last baseline;
}
.index-module__button-container__XdJBE {
  margin-top: 12px;
}
.index-module__date-picker__IJ90E {
  min-width: 260px;
}
.index-module__cards-container__bwrIx {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  margin-top: 20px;
  flex-wrap: wrap;
  margin-top: 40px;
}
.index-module__count-card__iEcUm {
  width: 280px;
  height: 160px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 15px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  color: #fff;
  position: relative;
  overflow: hidden;
  margin-top: 40px;
}
.index-module__count-card__iEcUm:hover {
  transform: scale(1.05);
}
@media only screen and (min-width: 700px) and (max-width: 992px) {
  .index-module__select-master-dropdown__rxobb {
    width: 120px !important;
  }
  .index-module__input-search__NTAy_ {
    min-width: 20%;
  }
}
/* Mobile view */
@media only screen and (max-width: 675px) {
  .index-module__head-container__b7Fke {
    display: none;
  }
  .index-module__head-container-1__BJ6rM {
    width: 100% !important;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .index-module__title-container__DYcHG {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .index-module__extra-container__HvwDj {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    width: 100%;
    margin-top: 10px;
  }
  .index-module__extra-container__HvwDj .index-module__order-1__o3RE4 {
    order: 1;
  }
  .index-module__order-2__r_j8_ {
    order: 0;
  }
  .index-module__search-component__width__PKL13 {
    width: 70%;
    margin-right: 10px;
  }
  .index-module__add-button__yQEWt {
    width: 30%;
    margin-left: 10px;
  }
  .index-module__mobile-add-request-btn__VopK3 {
    display: inline-block;
  }
}
@media (max-width: 480px) {
  .index-module__master-container__C1aHC,
  .index-module__show-date-filter-value__bfxDG,
  .index-module__filters-container__l6edW {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  .index-module__master-container__C1aHC .index-module__section2___NDzc,
  .index-module__show-date-filter-value__bfxDG .index-module__section2___NDzc,
  .index-module__filters-container__l6edW .index-module__section2___NDzc {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  .index-module__master-filters__U0S1F {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 0.5rem;
  }
  /* Each child takes ~50% width */
  .index-module__master-filters__U0S1F > div {
    width: calc(50% - 0.25rem);
    /* 2 columns with 0.5rem gap */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MasterManagement/index.module.less"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;AAC7F,qGAAqG;AACrG;;;;;CAKC;AACD;EACE,0CAA0C;EAC1C,WAAW;AACb;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,MAAM;EACN,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,UAAU;EACV,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,oDAAoD;EACpD,cAAc;AAChB;AACA;EACE,oDAAoD;EACpD,cAAc;AAChB;AACA;EACE,oDAAoD;EACpD,cAAc;AAChB;AACA;EACE,oDAAoD;EACpD,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yCAAyC;EAC3C;AACF;AACA;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yCAAyC;EAC3C;AACF;AACA;EACE,gEAA2C;EAC3C,cAAc;AAChB;AACA;EACE,kEAA6C;EAC7C,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,mEAAmE;EACnE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,cAAc;EAChB;AACF;AACA,gBAAgB;AAChB;EACE;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,qBAAqB;EACvB;AACF;AACA;EACE;;;IAGE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;EACA;;;IAGE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;EACA;IACE,aAAa;IACb,eAAe;IACf,2BAA2B;IAC3B,uBAAuB;IACvB,WAAW;EACb;EACA,gCAAgC;EAChC;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;AACF","sourcesContent":["/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n/* for components whose styles are define, those components will pick below two configurable colors */\n/* \n - for components whose styles are not defined, those components will pick below two default colors* \n - add styles for those components if you want configurable colors.\n - @primary-color and @secondary-color cannot be changed because it is used by antd, if removed it will default to antd default primary and secondary color.\n - this is a workaround as antd core styles do not accept css variables as less variable values.\n*/\n::selection {\n  background-color: var(--app-primary-color);\n  color: #fff;\n}\n.title-container {\n  display: flex;\n  justify-content: flex-start;\n  gap: 30px;\n  align-items: center;\n}\n.extra-container {\n  text-align: center;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 30px;\n}\n.parking-history-filters {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n  margin-top: -1rem;\n}\n.scrollContainer {\n  max-height: 65vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-right: 8px;\n}\n.vehicleQuotaTable {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.tableHeader,\n.tableRow {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n.tableHeader {\n  font-weight: bold;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #ccc;\n  position: sticky;\n  top: 0;\n  background: #fff;\n  z-index: 1;\n}\n.datepicker__width {\n  width: 24vw;\n}\n.dropdown__selector {\n  width: 18vw;\n  font-size: 14px;\n  border-radius: 7px;\n}\n.dropdown__selector_small {\n  width: 14vw;\n  font-size: 14px;\n  border-radius: 7px;\n}\n.dropdown-filter-label {\n  font-size: 15px;\n  font-weight: bolder;\n}\n.head-container {\n  width: 100% !important;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.head-container-1 {\n  display: none;\n}\n.select-master {\n  margin-left: 200px;\n  margin-top: -17px;\n  display: flex;\n  justify-content: flex-start;\n}\n.input-dropdown {\n  width: 100%;\n}\n.input-search {\n  min-width: 100%;\n}\n.div-container {\n  position: absolute;\n  top: 10px;\n  padding-left: 184px;\n  display: flex;\n  width: 100%;\n}\n.search-container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10%;\n  width: 100%;\n}\n.select-master-dropdown {\n  width: 250px;\n}\n.icon-delete-close {\n  font-size: 23px;\n}\n.icon-save {\n  font-size: 23px;\n  margin-right: 25px;\n}\n.action-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n  margin-right: 1rem;\n}\n.logo-image-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 40px;\n}\n.delete-customer-icon {\n  color: red;\n  font-size: 20px;\n  margin-left: 10px;\n}\n.image {\n  width: 50px;\n  height: 50px;\n}\n.disabled {\n  color: grey;\n  cursor: not-allowed !important;\n}\n.button-m01 {\n  margin: 0rem 1rem;\n}\n.form-itemFloatR20 {\n  float: right;\n  margin-top: 20px;\n}\n.textCenter {\n  text-align: center;\n}\n.formDiv {\n  margin-top: 0px;\n  padding-bottom: 3rem;\n  padding-top: 0px;\n}\n.formDivExtended {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n.from-Item-selectDiv {\n  width: 100%;\n}\n.ant-select-option {\n  max-height: 200px;\n  overflow-y: auto;\n}\n.master-data-table {\n  margin-top: 1.6rem;\n}\n.master-container {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.master-container .section1 {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 2rem;\n}\n.master-container .section2 {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 1rem;\n}\n.mb8 {\n  margin-bottom: 8px;\n}\n.excel-button-container {\n  padding: 0;\n  margin-left: 10px;\n}\n.excel-icon {\n  color: green;\n  font-size: 28px;\n}\n.pdf-icon {\n  color: red;\n  font-size: 34px;\n  cursor: pointer;\n}\n.pdf-icon-disabled {\n  color: gray;\n  font-size: 34px;\n  cursor: not-allowed;\n}\n.highlighted-record-isVisitor {\n  background-color: rgba(52, 152, 179, 0.5) !important;\n  color: #000000;\n}\n.highlighted-record-booking {\n  background-color: rgba(126, 196, 95, 0.5) !important;\n  color: #000000;\n}\n.highlighted-record-retrieval {\n  background-color: rgba(52, 152, 179, 0.5) !important;\n  color: #000000;\n}\n.highlighted-record-storage {\n  background-color: rgba(245, 127, 42, 0.5) !important;\n  color: #000000;\n}\n.button-font-size {\n  font-size: 18px;\n}\n.stats-container {\n  margin-top: -10px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-bottom: 10px;\n  gap: 20px;\n  font-size: 14px;\n}\n.spacing-between-counts {\n  margin-left: 15px;\n}\n.master-filters {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 20px;\n  margin-top: 15px;\n  margin-bottom: -7px;\n}\n.filter-master-dropdown {\n  width: 213px;\n}\n.advance-booking-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100% !important;\n}\n.advance-booking-container .field-section {\n  width: 100% !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n@keyframes blink-booking {\n  0% {\n    background-color: rgba(126, 196, 95, 0.5);\n  }\n  50% {\n    background-color: #ff7400;\n  }\n  100% {\n    background-color: rgba(126, 196, 95, 0.5);\n  }\n}\n@keyframes blink-retrieval {\n  0% {\n    background-color: rgba(52, 152, 179, 0.5);\n  }\n  50% {\n    background-color: #ff7400;\n  }\n  100% {\n    background-color: rgba(52, 152, 179, 0.5);\n  }\n}\n.blinking-record-execution-booking {\n  animation: blink-booking 1s linear infinite;\n  color: #000000;\n}\n.blinking-record-execution-retrieval {\n  animation: blink-retrieval 1s linear infinite;\n  color: #000000;\n}\n.text-bold {\n  font-weight: bolder;\n}\n.filters-container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n.show-date-filter-value {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  margin-top: 1rem;\n}\n.iconButton-container {\n  display: flex;\n  align-items: center;\n  margin: 0px;\n}\n@media only screen and (max-width: 700px) {\n  .select-master-dropdown {\n    width: 150px !important;\n  }\n  .input-search {\n    display: none;\n  }\n}\n.header-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n.filters-container {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  align-content: last baseline;\n}\n.button-container {\n  margin-top: 12px;\n}\n.date-picker {\n  min-width: 260px;\n}\n.cards-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 40px;\n  margin-top: 20px;\n  flex-wrap: wrap;\n  margin-top: 40px;\n}\n.count-card {\n  width: 280px;\n  height: 160px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  border-radius: 15px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;\n  color: #fff;\n  position: relative;\n  overflow: hidden;\n  margin-top: 40px;\n}\n.count-card:hover {\n  transform: scale(1.05);\n}\n@media only screen and (min-width: 700px) and (max-width: 992px) {\n  .select-master-dropdown {\n    width: 120px !important;\n  }\n  .input-search {\n    min-width: 20%;\n  }\n}\n/* Mobile view */\n@media only screen and (max-width: 675px) {\n  .head-container {\n    display: none;\n  }\n  .head-container-1 {\n    width: 100% !important;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  .title-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n  }\n  .extra-container {\n    display: flex;\n    flex-direction: column-reverse;\n    align-items: center;\n    width: 100%;\n    margin-top: 10px;\n  }\n  .extra-container .order-1 {\n    order: 1;\n  }\n  .order-2 {\n    order: 0;\n  }\n  .search-component__width {\n    width: 70%;\n    margin-right: 10px;\n  }\n  .add-button {\n    width: 30%;\n    margin-left: 10px;\n  }\n  .mobile-add-request-btn {\n    display: inline-block;\n  }\n}\n@media (max-width: 480px) {\n  .master-container,\n  .show-date-filter-value,\n  .filters-container {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n  .master-container .section2,\n  .show-date-filter-value .section2,\n  .filters-container .section2 {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n  .master-filters {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n  /* Each child takes ~50% width */\n  .master-filters > div {\n    width: calc(50% - 0.25rem);\n    /* 2 columns with 0.5rem gap */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title-container": `index-module__title-container__DYcHG`,
	"extra-container": `index-module__extra-container__HvwDj`,
	"parking-history-filters": `index-module__parking-history-filters__C6JA4`,
	"scrollContainer": `index-module__scrollContainer__fDMwk`,
	"vehicleQuotaTable": `index-module__vehicleQuotaTable__xlnwT`,
	"tableHeader": `index-module__tableHeader__s0TcY`,
	"tableRow": `index-module__tableRow__UW0FM`,
	"datepicker__width": `index-module__datepicker__width__qsR7w`,
	"dropdown__selector": `index-module__dropdown__selector__Fe5og`,
	"dropdown__selector_small": `index-module__dropdown__selector_small__KfIC3`,
	"dropdown-filter-label": `index-module__dropdown-filter-label__MwYe9`,
	"head-container": `index-module__head-container__b7Fke`,
	"head-container-1": `index-module__head-container-1__BJ6rM`,
	"select-master": `index-module__select-master__GFaHW`,
	"input-dropdown": `index-module__input-dropdown__0NJQy`,
	"input-search": `index-module__input-search__NTAy_`,
	"div-container": `index-module__div-container__XI6nT`,
	"search-container": `index-module__search-container__yThly`,
	"select-master-dropdown": `index-module__select-master-dropdown__rxobb`,
	"icon-delete-close": `index-module__icon-delete-close__Tb02h`,
	"icon-save": `index-module__icon-save__a2QOK`,
	"action-icon": `index-module__action-icon__ciGZ7`,
	"logo-image-icon": `index-module__logo-image-icon__fyvO2`,
	"delete-customer-icon": `index-module__delete-customer-icon__IugiB`,
	"image": `index-module__image__r1fUM`,
	"disabled": `index-module__disabled__K_EBg`,
	"button-m01": `index-module__button-m01__d1Z15`,
	"form-itemFloatR20": `index-module__form-itemFloatR20__KIl99`,
	"textCenter": `index-module__textCenter__mnCva`,
	"formDiv": `index-module__formDiv__sCkl4`,
	"formDivExtended": `index-module__formDivExtended__grysV`,
	"from-Item-selectDiv": `index-module__from-Item-selectDiv__b8p08`,
	"ant-select-option": `index-module__ant-select-option__fPCuf`,
	"master-data-table": `index-module__master-data-table__vqMci`,
	"master-container": `index-module__master-container__C1aHC`,
	"section1": `index-module__section1__b7vAH`,
	"section2": `index-module__section2___NDzc`,
	"mb8": `index-module__mb8__OjmFl`,
	"excel-button-container": `index-module__excel-button-container__YQ6SZ`,
	"excel-icon": `index-module__excel-icon__Pvvpt`,
	"pdf-icon": `index-module__pdf-icon__JEmn2`,
	"pdf-icon-disabled": `index-module__pdf-icon-disabled__SZAuY`,
	"highlighted-record-isVisitor": `index-module__highlighted-record-isVisitor__OfyZt`,
	"highlighted-record-booking": `index-module__highlighted-record-booking__UIUwR`,
	"highlighted-record-retrieval": `index-module__highlighted-record-retrieval__UAx1L`,
	"highlighted-record-storage": `index-module__highlighted-record-storage__yXFSo`,
	"button-font-size": `index-module__button-font-size__CFKZ2`,
	"stats-container": `index-module__stats-container__PhUZe`,
	"spacing-between-counts": `index-module__spacing-between-counts__NqDsz`,
	"master-filters": `index-module__master-filters__U0S1F`,
	"filter-master-dropdown": `index-module__filter-master-dropdown__luKmK`,
	"advance-booking-container": `index-module__advance-booking-container__uyuxl`,
	"field-section": `index-module__field-section__OSNYo`,
	"blinking-record-execution-booking": `index-module__blinking-record-execution-booking__lfFSj`,
	"blink-booking": `index-module__blink-booking__LMf8d`,
	"blinking-record-execution-retrieval": `index-module__blinking-record-execution-retrieval__HUb9k`,
	"blink-retrieval": `index-module__blink-retrieval__lwlFa`,
	"text-bold": `index-module__text-bold__feQch`,
	"filters-container": `index-module__filters-container__l6edW`,
	"show-date-filter-value": `index-module__show-date-filter-value__bfxDG`,
	"iconButton-container": `index-module__iconButton-container__HVBVa`,
	"header-container": `index-module__header-container__rxhjb`,
	"button-container": `index-module__button-container__XdJBE`,
	"date-picker": `index-module__date-picker__IJ90E`,
	"cards-container": `index-module__cards-container__bwrIx`,
	"count-card": `index-module__count-card__iEcUm`,
	"order-1": `index-module__order-1__o3RE4`,
	"order-2": `index-module__order-2__r_j8_`,
	"search-component__width": `index-module__search-component__width__PKL13`,
	"add-button": `index-module__add-button__yQEWt`,
	"mobile-add-request-btn": `index-module__mobile-add-request-btn__VopK3`
};
export default ___CSS_LOADER_EXPORT___;
